import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUpOutlined } from "@ant-design/icons";

const ScrollToTop = () => {
  const [showTop, setShowTop] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const el = document.querySelector(".scrollable-content");

    const onScroll = () => {
      setShowTop(el.scrollTop > 600);
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [location.pathname]);
  return (
    <>
      {showTop && (
        <div
          onClick={() =>
            document.querySelector(".scrollable-content").scrollTo({ top: 0, behavior: "smooth" })
          }
          className="fixed right-6 bottom-20 h-10 w-10 bg-[#a33434] text-white rounded-full flex items-center justify-center cursor-pointer shadow-lg"
        >
          <img src="/assets/icons/arrow_upward_icon.svg" />
        </div>
      )}
    </>
  );
};
export default ScrollToTop;
